import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import jwtInterceoptor from "../../../../api/jwtInterceptor";
import { AddNewPropanePopupForm } from "../../../../components/parts/forms";
import { POST_API_URLS } from "../../../../utils/constant";
import styles from "./style.module.scss";
import { CardWrapper } from "../../../../components/wrapper";
import { FormErrorPopup } from "../../../../components/parts/popups";

const AddPropanePopup = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const navigate = useNavigate();

  const location = useLocation();

  console.log("edit data", location.state);

  const addNewPropanePopupHandler = (data) => {
    setLoading(true);
    let formData = new FormData();
    for (let k in data) {
      formData.append(k, data[k]);
    }

    jwtInterceoptor
      .post(POST_API_URLS.ADD_PROPANE_POPUP, formData)
      .then((response) => {
        console.log(response.data);
        navigate("/dashboard/propane-popup");
      })
      .catch((error) => {
        setLoading(false);
        setError(error.message);
        console.log("Error", error);
      });
  };

  const updatePropanePopupHandler = (data) => {
    setLoading(true);
    let formData = new FormData();
    for (let k in data) {
      formData.append(k, data[k]);
    }

    jwtInterceoptor
      .patch(POST_API_URLS.ADD_PROPANE_POPUP + `${data.id}/`, formData)
      .then((response) => {
        console.log(response.data);
        navigate("/dashboard/propane-popup");
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status === 403) {
          setError("You dont have permission to add propane popups.");
        } else {
          setError(error.message);
        }
        console.log("Error", error);
      });
  };

  return (
    <>
      <div className={styles.addPropanePopupContainer}>
        <CardWrapper>
          <AddNewPropanePopupForm
            updateData={updatePropanePopupHandler}
            data={addNewPropanePopupHandler}
            loading={loading}
            formInitialValues={location.state || null}
          />
        </CardWrapper>
      </div>
      {error && <FormErrorPopup error={error} close={() => setError(false)} />}
    </>
  );
};

export default AddPropanePopup;
